const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const isStoreFieldNameArgs = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

const getStoreFieldNameArgs = (storeFieldName: string, prop: string) => {
  const match = storeFieldName.match(new RegExp(`^${escapeRegExp(prop)}\\((.*)\\)$`))
  if (!match?.[1]) return null

  try {
    const args: unknown = JSON.parse(match[1])
    if (!isStoreFieldNameArgs(args)) return null

    return args
  } catch {
    return null
  }
}

export { getStoreFieldNameArgs }
